import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import useThemeStyles from '../theme/useThemeStyles';

function Maintenance() {
  const styles = useThemeStyles();
  return (
    <Box sx={{ 
      minHeight: '100vh',
      backgroundColor: 'secondary.main',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 4
    }}>
      {/* Logo */}
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          mb: 4
        }}
      >
        <img src={`${process.env.PUBLIC_URL}/img/logo.svg`} alt="Idotoo Logo" style={{ height: '60px' }} />
      </Box>

      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <Typography component="h2" className="pagename" sx={styles.text.pagename}>
            Platform Temporarily Closed
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            The platform is currently closed or undergoing maintenance. 
            We will notify you when registration and login are available again.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Thank you for your patience.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default Maintenance;

